import { render, staticRenderFns } from "./FinanceCategoryTranslate.vue?vue&type=template&id=64e542bd"
import script from "./FinanceCategoryTranslate.vue?vue&type=script&lang=js"
export * from "./FinanceCategoryTranslate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports